export const config = {
  graphqlEndpoint:
    process.env.REACT_APP_ADMIN_GRAPHQL_URL ||
    process.env.REACT_APP_GRAPHQL_ENDPOINT ||
    "https://break3-api.inite.health/graphql",
  apiUrl:
    process.env.REACT_APP_ADMIN_GRAPHQL_URL ||
    process.env.REACT_APP_GRAPHQL_ENDPOINT ||
    "https://break3-api.inite.health/graphql",
  authServiceUrl:
    process.env.REACT_APP_AUTH_SERVICE_URL || "https://auth.inite.ai",
};
